"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _standardFont = _interopRequireDefault(require("./standardFont"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var fontCache = {};
var IGNORED_CODE_POINTS = [173];
var getFontSize = R.pathOr(12, ['attributes', 'fontSize']);
var getOrCreateFont = function getOrCreateFont(name) {
  if (fontCache[name]) return fontCache[name];
  var font = new _standardFont.default(name);
  fontCache[name] = font;
  return font;
};
var getDefaultFallbackFont = function getDefaultFallbackFont() {
  return getOrCreateFont('Helvetica');
};
var isGlyphAvailable = function isGlyphAvailable(codePoint, font) {
  return font.hasGlyphForCodePoint(codePoint);
};

/**
 * Determines the font that can render a specific character
 * 
 * Priority Order: (desired font family) > (first feasible of the specified fallback font families) > Helvetica
 * @returns Font
 */
var determineFont = function determineFont(codePoint, defaultFont, fallbackFonts) {
  var possibleFonts = [].concat(fallbackFonts);
  if (defaultFont) possibleFonts.unshift(defaultFont);
  for (var i = 0; i < possibleFonts.length; i += 1) {
    if (IGNORED_CODE_POINTS.includes(codePoint)) return possibleFonts[i];
    if (isGlyphAvailable(codePoint, possibleFonts[i])) return possibleFonts[i];
  }
  if (!possibleFonts[0]) {
    throw new Error('Default font is null');
  }
  return possibleFonts[0] || getDefaultFallbackFont();
};
var fontSubstitution = function fontSubstitution() {
  return function (_ref) {
    var string = _ref.string,
      runs = _ref.runs;
    var lastFont = null;
    var lastFontSize = null;
    var lastIndex = 0;
    var index = 0;
    var res = [];
    for (var i = 0; i < runs.length; i += 1) {
      var run = runs[i];
      var defaultFont = typeof run.attributes.font === 'string' ? getOrCreateFont(run.attributes.font) : run.attributes.font;
      var fallbackFonts = [].concat((run.attributes.fallbackFonts || []).map(function (font) {
        return typeof font === 'string' ? getOrCreateFont(font) : font;
      }), [getDefaultFallbackFont()]);
      if (string.length === 0) {
        res.push({
          start: 0,
          end: 0,
          attributes: {
            font: defaultFont
          }
        });
        break;
      }
      var chars = string.slice(run.start, run.end);
      for (var j = 0; j < chars.length; j += 1) {
        var char = chars[j];
        var codePoint = char.codePointAt();

        // Determine which font can be used to render a character into the PDF
        var font = determineFont(codePoint, defaultFont, fallbackFonts);
        var fontSize = getFontSize(run);

        // If anything that would impact res has changed, update it
        if (font !== lastFont || fontSize !== lastFontSize || font.unitsPerEm !== lastFont.unitsPerEm) {
          if (lastFont) {
            res.push({
              start: lastIndex,
              end: index,
              attributes: {
                font: lastFont,
                scale: lastFontSize / lastFont.unitsPerEm
              }
            });
          }
          lastFont = font;
          lastFontSize = fontSize;
          lastIndex = index;
        }
        index += char.length;
      }
    }
    if (lastIndex < string.length) {
      var _fontSize = getFontSize(R.last(runs));
      res.push({
        start: lastIndex,
        end: string.length,
        attributes: {
          font: lastFont,
          scale: _fontSize / lastFont.unitsPerEm
        }
      });
    }
    return {
      string: string,
      runs: res
    };
  };
};
var _default = exports.default = fontSubstitution;